module.exports = __webpack_public_path__ + "img/Boy_030010.a88a5c04.png";